import { Navigate, useResolvedPath } from 'react-router-dom';

/**
 * Sends an unrecognised sub-path back to the domain index.
 *
 * Why not `<Navigate to="" replace />`: under `v7_relativeSplatPath` — which
 * both the shell's router and `main.jsx` enable — a relative target inside a
 * `path="*"` route resolves against the matched splat, so `""` resolves to the
 * very URL that did not match. The page then renders nothing and the URL never
 * changes. `useResolvedPath('..')` steps out of the splat match to the route that owns
 * it — the domain root — and stays relative, so the domain can be mounted
 * anywhere without hardcoding `/unified-profiles`, which the embed contract
 * forbids.
 */
function DomainIndexRedirect() {
  const { pathname } = useResolvedPath('..');

  return <Navigate to={pathname} replace />;
}

export default DomainIndexRedirect;
